import { cn } from "@/lib/utils";
import { Icon } from "./Icon";

export interface EmptyStateProps {
  /** Glifo de Material Symbols. `search_off` cuando el filtro no arroja nada. */
  icono?: string;
  /**
   * UNA línea que diga qué falta. Sin ilustraciones, sin párrafos y sin
   * botones grandes: el vacío informa, no vende.
   */
  mensaje: string;
  /** Acción opcional, discreta (outline chico). */
  accion?: React.ReactNode;
  /** Recuadro punteado — para el vacío que ocupa el lugar de una tabla. */
  bordeado?: boolean;
  className?: string;
}

/** Estado vacío del Design System: ícono 26px + una línea de 13.5px. */
export function EmptyState({
  icono = "search_off",
  mensaje,
  accion,
  bordeado = false,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-1.5 px-6 py-[30px] text-center",
        bordeado && "border-border-strong bg-surface-muted rounded-xl border border-dashed",
        className
      )}
    >
      <Icon name={icono} size={26} className="text-icon-soft" />
      <span className="text-muted-foreground text-[13.5px]">{mensaje}</span>
      {accion && <div className="mt-1.5">{accion}</div>}
    </div>
  );
}
